import AdminForm from './AdminForm';
import './styles.scss';

const exports = { AdminForm };

export default exports;
